import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon } from 'lucide-react';
const locations = ['Queen Creek', 'Gilbert', 'Chandler', 'Mesa', 'San Tan Valley', 'Apache Junction', 'Gold Canyon', 'Florence', 'Coolidge', 'Tempe', 'Scottsdale', 'Ahwatukee', 'Fountain Hills'];
export function ServiceArea() {
  return <section id="service-area" className="bg-brand-dark py-24 px-6" data-id="element-228">
      <div className="max-w-7xl mx-auto" data-id="element-229">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-230">
          <div className="flex items-center gap-4 mb-4" data-id="element-231">
            <div className="w-10 h-[2px] bg-brand-green" data-id="element-232" />
            <span className="font-condensed uppercase text-brand-green tracking-widest font-semibold" data-id="element-233">
              Service Area
            </span>
          </div>
          <h2 className="text-4xl sm:text-5xl md:text-7xl text-white mb-4 md:mb-6" data-id="element-234">
            WHERE WE <span className="text-brand-green" data-id="element-235">SERVE</span>
          </h2>
          <p className="font-barlow text-base md:text-lg text-brand-gray max-w-4xl leading-relaxed" data-id="element-236">
            Ultimate Pest is a family-owned and operated pest control company
            proudly serving homeowners, businesses, HOAs, and commercial
            properties across the Phoenix metro area and throughout the East
            Valley. Based in{' '}
            <span className="text-white font-semibold" data-id="element-237">
              Queen Creek, Arizona
            </span>
            , we provide professional pest control services across the Valley.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3" data-id="element-238">
          {locations.map((location, index) => <motion.div key={location} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="group bg-brand-card border border-white/5 hover:border-brand-green/40 px-3 md:px-5 py-3 md:py-4 flex items-center gap-2 md:gap-3 transition-all duration-300" data-id="element-239">
              <MapPinIcon className="w-4 h-4 text-brand-green flex-shrink-0" data-id="element-240" />
              <span className="font-condensed uppercase text-white tracking-wider text-xs md:text-sm group-hover:text-brand-green transition-colors" data-id="element-241">
                {location}
              </span>
            </motion.div>)}
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: locations.length * 0.05
        }} className="bg-brand-green/10 border border-brand-green/30 px-5 py-4 flex items-center gap-3" data-id="element-242">
            <MapPinIcon className="w-4 h-4 text-brand-green flex-shrink-0" data-id="element-243" />
            <span className="font-condensed uppercase text-brand-green tracking-wider text-sm" data-id="element-244">
              + Surrounding Areas
            </span>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}